export default __webpack_public_path__ + "static/media/mail.9cb43631.svg";